import EmployeesVacatiions from './employees_vacations/EmployeesVacations';
import Calendar from './calendar/Calendar';
import EmployeesTimeLines from './employees_time_lines/EmployeesTimeLines';
const router = [
  {
    type: 'private',
    path: '/saldo-vacaciones',
    roles: ['administrador', 'jefe'],
    component: EmployeesVacatiions,
    exact: true,
  },
  {
    type: 'private',
    path: '/planificador-vacaciones/:username',
    roles: ['administrador', 'jefe'],
    component: Calendar,
    exact: true,
  },
  {
    type: 'private',
    path: '/agenda-seguimiento-vacaciones',
    roles: ['administrador', 'empleado', 'jefe'],
    component: EmployeesTimeLines,
    exact: true,
  },
];

export default router;